import { Link } from 'react-router-dom';
import { MainLayout } from '@templates/index';
import { LEGAL_CONFIG } from '@/config/legal';

const DistanceSalesPage = () => {
  return (
    <MainLayout>
      <div className="max-w-4xl mx-auto py-12 px-4">
        <div className="prose prose-lg max-w-none">
          <h1 className="text-3xl font-bold text-gray-900 mb-2">
            Mesafeli Satış Sözleşmesi
          </h1>
          <p className="text-gray-500 text-sm mb-2">
            Son Güncelleme Tarihi: {LEGAL_CONFIG.lastUpdated}
          </p>
          <p className="text-gray-500 text-xs mb-8">
            6502 sayılı Tüketicinin Korunması Hakkında Kanun ve Mesafeli Sözleşmeler Yönetmeliği
            kapsamında düzenlenmiştir.
          </p>

          {/* Madde 1 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Madde 1 — Taraflar</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              İşbu sözleşme; bir tarafta Lezzet Yolda platformu kullanıcısı (<strong>ALICI</strong>)
              ile diğer tarafta platform üzerinden ürün/hizmet satışı yapan üye işyeri (<strong>SATICI</strong>)
              ve bu satışa aracılık eden{' '}
              <strong>{LEGAL_CONFIG.companyName}</strong> (<strong>ARACI HİZMET SAĞLAYICI</strong>)
              arasında aşağıdaki şartlar dahilinde akdedilmiştir.
            </p>

            <div className="bg-gray-50 rounded-xl overflow-hidden border border-gray-200">
              <div className="px-6 py-4 border-b border-gray-200">
                <h3 className="font-semibold text-gray-900">Aracı Hizmet Sağlayıcı Bilgileri</h3>
              </div>
              <ul className="list-none pl-0 m-0 divide-y divide-gray-100">
                {[
                  { label: 'Unvan', value: LEGAL_CONFIG.companyName },
                  { label: 'MERSİS No', value: LEGAL_CONFIG.mersisNo },
                  { label: 'Vergi Kimlik No', value: LEGAL_CONFIG.taxNumber },
                  { label: 'Vergi Dairesi', value: LEGAL_CONFIG.taxOffice },
                  { label: 'Adres', value: LEGAL_CONFIG.fullAddress },
                  { label: 'E-posta', value: LEGAL_CONFIG.email },
                  { label: 'Telefon', value: LEGAL_CONFIG.phone },
                ].map((row) => (
                  <li key={row.label} className="flex px-6 py-3 gap-4">
                    <span className="font-semibold text-gray-900 w-36 shrink-0 text-sm">{row.label}</span>
                    <span className="text-gray-700 text-sm">
                      {row.label === 'E-posta' ? (
                        <a href={`mailto:${row.value}`} className="text-primary hover:underline">{row.value}</a>
                      ) : row.label === 'Telefon' ? (
                        <a href={`tel:${row.value}`} className="text-primary hover:underline">{row.value}</a>
                      ) : (
                        row.value
                      )}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="mt-4 bg-gray-50 rounded-xl border border-gray-200 px-6 py-4 space-y-2 text-sm text-gray-700">
              <p>
                <strong>SATICI Bilgileri:</strong> ALICI'nın sipariş verdiği ve platformda bilgileri
                yer alan üye işyeri (restoran vb.). Satıcı'ya ait bilgiler sipariş özeti ve
                faturada yer almaktadır.
              </p>
              <p>
                <strong>ALICI Bilgileri:</strong> Platforma üye olan ve sipariş veren kişi.
                Ad, soyad, adres ve iletişim bilgileri sipariş sırasında ALICI tarafından beyan edilir.
              </p>
            </div>
          </section>

          {/* Madde 2 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Madde 2 — Sözleşmenin Konusu</h2>
            <p className="text-gray-700 leading-relaxed">
              İşbu sözleşmenin konusu, ALICI'nın Lezzet Yolda platformu üzerinden elektronik
              ortamda siparişini yaptığı, nitelikleri ve satış fiyatı belirtilen ürünlerin/hizmetlerin
              satışı ve teslimi ile ilgili olarak{' '}
              <strong>6502 sayılı Tüketicinin Korunması Hakkında Kanun</strong> ve{' '}
              <strong>Mesafeli Sözleşmeler Yönetmeliği</strong> hükümleri gereğince tarafların
              hak ve yükümlülüklerinin saptanmasıdır.
            </p>
          </section>

          {/* Madde 3 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Madde 3 — Genel Hükümler</h2>
            <div className="space-y-4 text-gray-700">
              <div className="flex gap-3">
                <span className="font-semibold text-gray-900 shrink-0">3.1</span>
                <p className="leading-relaxed m-0">
                  ALICI, platformda sözleşme konusu ürünün temel nitelikleri, satış fiyatı,
                  ödeme şekli ve teslimata ilişkin ön bilgileri okuyup bilgi sahibi olduğunu ve
                  elektronik ortamda gerekli teyidi verdiğini beyan eder.
                </p>
              </div>
              <div className="flex gap-3">
                <span className="font-semibold text-gray-900 shrink-0">3.2</span>
                <p className="leading-relaxed m-0">
                  ARACI HİZMET SAĞLAYICI, SATICI ile ALICI arasındaki satış sözleşmesinin
                  tarafı olmayıp, yalnızca platformun kullanılmasını ve ödeme altyapısını
                  sağlamaktadır. Ürünün hazırlanması, kalitesi, teslimatı ve satış sonrası
                  hizmetlerden münhasıran SATICI sorumludur.
                </p>
              </div>
              <div className="flex gap-3">
                <span className="font-semibold text-gray-900 shrink-0">3.3</span>
                <p className="leading-relaxed m-0">
                  Sipariş konusu ürün, yasal 30 günlük süreyi aşmamak koşuluyla ALICI'nın
                  yerleşim yerinin uzaklığına bağlı olarak platformda belirtilen tahmini süre
                  içinde ALICI veya gösterdiği adresteki kişi/kuruluşa teslim edilir.
                </p>
              </div>
              <div className="flex gap-3">
                <span className="font-semibold text-gray-900 shrink-0">3.4</span>
                <p className="leading-relaxed m-0">
                  SATICI, sözleşme konusu ürünü eksiksiz, siparişte belirtilen niteliklere
                  uygun ve mevzuata uygun şekilde hazırlamak ve teslim etmekle yükümlüdür.
                </p>
              </div>
            </div>
          </section>

          {/* Madde 4 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Madde 4 — Cayma Hakkı</h2>
            <div className="bg-red-50 border border-red-200 rounded-xl p-6">
              <p className="text-red-900 leading-relaxed m-0">
                <strong>Mesafeli Sözleşmeler Yönetmeliği'nin 15. maddesi uyarınca;</strong>{' '}
                yiyecek ve içecek gibi çabuk bozulabilen veya son kullanma tarihi geçebilecek
                malların teslimine ilişkin sözleşmelerde <strong>cayma hakkı kullanılamaz</strong>.
                Bu kapsamda, ALICI tarafından verilen yemek siparişlerinde, siparişin SATICI
                tarafından hazırlanmaya başlanmasından sonra cayma ve iade hakkı bulunmamaktadır.
                Hazırlanmamış siparişlerin iptali için{' '}
                <Link to="/teslimat-iade" className="underline font-semibold">
                  Teslimat, İptal ve İade Koşulları
                </Link>{' '}
                sayfası geçerlidir.
              </p>
            </div>
          </section>

          {/* Madde 5 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">Madde 5 — Ödeme</h2>
            <div className="space-y-3 text-gray-700">
              <p className="leading-relaxed">
                Sipariş bedeli, ALICI'nın seçtiği ödeme yöntemine göre tahsil edilir:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>
                  <strong>Kredi/Banka Kartı:</strong> Ödeme, PCI-DSS sertifikalı{' '}
                  <strong>Iyzico</strong> altyapısı üzerinden güvenli biçimde gerçekleştirilir.
                  Kart bilgileri ham haliyle{' '}
                  <strong>{LEGAL_CONFIG.companyName}</strong> sistemlerinde saklanmaz; işlem
                  tokenizasyon yöntemiyle yürütülür.
                </li>
                <li>
                  <strong>Kapıda Nakit:</strong> Sipariş tesliminde kurye aracılığıyla tahsil edilir.
                </li>
              </ul>
              <div className="flex items-center gap-4 mt-4 p-4 bg-gray-50 rounded-xl border border-gray-200">
                <img src="/logos/visa.png" alt="Visa" className="h-8 object-contain" />
                <img src="/logos/mastercard.png" alt="Mastercard" className="h-8 object-contain" />
                <img src="/logos/iyzico.png" alt="Iyzico" className="h-8 object-contain" />
                <span className="text-xs text-gray-500">Güvenli ödeme altyapısı</span>
              </div>
            </div>
          </section>

          {/* Madde 6 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Madde 6 — Yetkili Mahkeme ve Tüketici Başvuru Yolları
            </h2>
            <p className="text-gray-700 leading-relaxed">
              İşbu sözleşmeden doğan uyuşmazlıklarda, T.C. Ticaret Bakanlığı'nca ilan edilen
              değere kadar <strong>Tüketici Hakem Heyetleri</strong>, bu değeri aşan
              uyuşmazlıklarda ise ALICI'nın veya SATICI'nın yerleşim yerindeki{' '}
              <strong>Tüketici Mahkemeleri</strong> yetkilidir. Tüketiciler ayrıca e-Devlet
              üzerinden <strong>Tüketici Bilgi Sistemi (TÜBİS)</strong>'ne başvurabilir.
            </p>
          </section>

          {/* Madde 7 */}
          <section className="mb-10">
            <h2 className="text-xl font-semibold text-gray-900 mb-4">
              Madde 7 — Yürürlük
            </h2>
            <p className="text-gray-700 leading-relaxed">
              ALICI, Lezzet Yolda platformu üzerinden sipariş verdiği anda işbu mesafeli satış
              sözleşmesini okuduğunu, anladığını ve tüm hükümlerini kabul ettiğini beyan etmiş
              sayılır. Sözleşme, siparişin onaylanmasıyla birlikte her iki taraf açısından
              bağlayıcı hale gelir.
            </p>
          </section>

          <div className="mt-12 pt-8 border-t border-gray-200 flex flex-wrap gap-4">
            <Link to="/teslimat-iade" className="text-primary hover:underline font-medium">
              Teslimat ve İade Koşulları
            </Link>
            <Link to="/terms" className="text-primary hover:underline font-medium">
              Kullanım Koşulları
            </Link>
            <Link to="/privacy" className="text-primary hover:underline font-medium">
              Gizlilik Politikası
            </Link>
            <Link to="/" className="text-primary hover:underline font-medium">
              ← Ana Sayfaya Dön
            </Link>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default DistanceSalesPage;
